import {
  workspace_v1_AcceptTermsRequest,
  workspaceV1AcceptTermsMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { defaultOptions } from '@/utils/query';

export const useAcceptTermOptions = (workspace: string) => {
  return useMutation({
    mutationFn: ({ data }: { data: workspace_v1_AcceptTermsRequest }) =>
      workspaceV1AcceptTermsMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: data, path: { workspace } }),
  });
};
